/* import __COLOCATED_TEMPLATE__ from './matching-timetable-dropdown-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();